'use strict';

/*global services*/

function K2FormationViewer(modal /*nepovinne*/) {
  this.modal = modal;

  this.init();
}

K2FormationViewer.prototype = $.extend({}, {
  constructor: 'K2FormationViewer',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.view-formation', function () {
      _this.viewFormation($(this).attr('href'), $(this).data('width'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  viewFormation: function viewFormation(url, width, callback) {
    var _this = this;

    var html = '';
    html += '<div class="k2-formation-viewer-wrapper">';
    html +=   '<iframe src="' + url + '" class="k2-formation-viewer"></iframe>';
    html += '</div>';

    _this.modal.open({
      width: 'auto',
      maxWidth: width ? width : 800,
      closeCallBack: callback
    });
    _this.modal.content(html);
    _this.modal.block();
    _this.modal.contentDOM().find('.k2-formation-viewer').bind('load', function () {
      var $iframeContent = _this.modal.contentDOM().find('.k2-formation-viewer').contents();
      $iframeContent.find('.pageWPB, .pageWOPB').css({
        margin: '0 auto',
        borderTop: 'none',
        borderBottom: 'none'
      });
      _this.modal.unBlock();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = _this.modal ? _this.modal : services.get('modal');
    _this.registerCallbacks();

    return _this;
  }
});
